var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_1781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4206 4.4862H13.43V1.82284C13.43 1.34936 12.996 0.935059 12.5 0.935059C12.0039 0.935059 11.5699 1.34936 11.5699 1.82284V4.4862H2.57932C1.40124 4.4862 0.40918 5.43317 0.40918 6.55769V17.2111C0.40918 18.3356 1.40124 19.2826 2.57932 19.2826H8.03567L5.4935 23.4848C5.24549 23.8991 5.3695 24.4317 5.80352 24.6685C5.92753 24.7277 6.11354 24.7869 6.23755 24.7869C6.54757 24.7869 6.85759 24.6093 7.0436 24.3134L10.1438 19.2234H14.7321L17.8323 24.3134C18.0183 24.6093 18.3283 24.7869 18.6383 24.7869C18.8244 24.7869 18.9484 24.7277 19.0724 24.6685C19.5064 24.4317 19.6924 23.8991 19.3824 23.4848L16.8402 19.2826H22.4206C23.5987 19.2826 24.5907 18.3356 24.5907 17.2111V6.55769C24.5907 5.43317 23.5987 4.4862 22.4206 4.4862ZM22.7306 17.2111C22.7306 17.3887 22.6066 17.507 22.4206 17.507H2.57932C2.39331 17.507 2.2693 17.3887 2.2693 17.2111V6.55769C2.2693 6.38014 2.39331 6.26176 2.57932 6.26176H22.4206C22.6066 6.26176 22.7306 6.38014 22.7306 6.55769V17.2111Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4606 12.7723H7.53992C7.04389 12.7723 6.60986 13.1866 6.60986 13.6601C6.60986 14.1336 7.04389 14.5479 7.53992 14.5479H17.4606C17.9566 14.5479 18.3906 14.1336 18.3906 13.6601C18.3906 13.1866 17.9566 12.7723 17.4606 12.7723ZM17.4606 9.22119H7.53992C7.04389 9.22119 6.60986 9.63549 6.60986 10.109C6.60986 10.5825 7.04389 10.9968 7.53992 10.9968H17.4606C17.9566 10.9968 18.3906 10.5825 18.3906 10.109C18.3906 9.63549 17.9566 9.22119 17.4606 9.22119Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_1781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTraining);
export default __webpack_public_path__ + "static/media/ic_training.2d725a4b2113397a3100405e46a76788.svg";
export { ForwardRef as ReactComponent };